import React, { useState, useEffect, useLayoutEffect } from 'react'
import { graphql } from 'gatsby'
import { connect } from 'react-redux'
import Layout from '../../templates/Master'
import ProductDetails from '../../templates/ProductDetails'
import PageBuilder from '../../views/pageBuilder'
import Loader from '../../components/loaders/PageLoader'
import { dialogState } from '../../system/redux/reducers/dialog'
import { previewState } from '../../system/redux/reducers/preview'
import {
    onSnapshot,
    query as fsQuery,
    collection,
    doc,
    where,
} from 'firebase/firestore'
import { db } from '../../system/firebase/index'

function CarPage({
    data,
    dispatch,
    location,
    isAuthenticated,
    isVerifying,
    verificationComplete,
    params,
}) {
    const fallback = <Loader />
    const obj = data?.collection
    const [pageData, setPageData] = useState(obj)
    const { modules } = obj?.content
    const queryParams = new URLSearchParams(location.search)
    const id = queryParams.get('id')
    const auxData = {
        collection: data.allCollection.edges,
        post: data.allPost.edges,
        page: data.allPage.edges,
    }

    // Creating a unix timestamp of last midnight (when the chron is set to run to create nodes)
    let midnight = new Date()
    midnight.setHours(0, 0, 0, 0)
    midnight = midnight.getTime() / 1000

    useEffect(() => {
        if (location.search) {
            if (
                queryParams.get('preview') === 'true' &&
                queryParams.get('id')
            ) {
                dispatch(previewState(queryParams.get('id')))
            }
        }
    }, [location, isVerifying, isAuthenticated, verificationComplete])

    useLayoutEffect(() => {
        let isCancelled = false
        let single = false
        let q = fsQuery(
            collection(db, 'collectionSearch'),
            where('slug', '==', params.slug)
        )
        if (id) {
            q = doc(db, 'collectionSearch', id)
            single = true
        }
        onSnapshot(q, (snapshot) => {
            if (isCancelled) {
                return
            }
            const output = []
            if (single) {
                if (snapshot.exists()) {
                    const data = snapshot.data()
                    if (
                        !isVerifying &&
                        !isAuthenticated &&
                        verificationComplete &&
                        (data.visibility === 'draft' || !data.profileActive)
                    ) {
                        dispatch(
                            dialogState(
                                JSON.stringify({ open: true, id: 'LOGIN' })
                            )
                        )
                    } else {
                        output.push(data)
                    }
                }
            } else {
                snapshot.forEach((doc) => {
                    output.push(doc.data())
                })
            }
            // Checking to see if the page has been updated since the last cron run, if it has
            // then we'll replace the page data with the database view. Or, if we're previewing.
            if (
                output[0]?.date_modified.toDate().getTime() / 1000 > midnight ||
                (id && isAuthenticated)
            ) {
                setPageData(output[0])
            }
        })
        return () => {
            isCancelled = true
        }
    }, [id, verificationComplete])

    return (
        <Layout
            location={location}
            pageTitle={pageData?.title}
        >
            {modules?.length ? (
                <PageBuilder
                    auxData={auxData}
                    dataFallback={fallback}
                    data={pageData}
                    id={obj?.slug || pageData.slug}
                />
            ) : (
                <ProductDetails data={pageData} />
            )}
        </Layout>
    )
}

function mapStateToProps(state) {
    return {
        isAuthenticated: state.Auth.isAuthenticated,
        isVerifying: state.Auth.isVerifying,
        verificationComplete: state.Auth.verificationComplete,
        previewID: state.Preview.id,
    }
}

export default connect(mapStateToProps)(CarPage)

export const query = graphql`
    query ($slug: String) {
        collection(slug: { eq: $slug }) {
            categories
            characteristics {
                ...CharacteristicsFragment
            }
            date_published
            media {
                ...CollectionMediaFragment
            }
            slug
            title
            visibility
            content {
                excerpt
                keypoints
                description
                modules
            }
        }
        allCollection(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    media {
                        set {
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_published
                    published_by
                    slug
                    title
                    item_id
                    categories
                    content {
                        description
                        excerpt
                    }
                }
            }
        }
        allPost(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    categories
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
        allPage(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
    }
`
